import { render, staticRenderFns } from "./CookiesDisabled.vue?vue&type=template&id=765d6fdd"
import script from "./CookiesDisabled.vue?vue&type=script&lang=js"
export * from "./CookiesDisabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports